<template>
  <form @submit.prevent="resendValidateCode" class="form-group">
    <label>Téléphone</label>
    <input
      type="text"
      v-model="phone"
      placeholder="+237690000000"
    />
    <div class="btn-group">
      <button type="submit" class="btn btn-primary">Valider</button>
    </div>
  </form>
</template>

<script setup>
import { config } from '@/config/env.js'
import { ref } from 'vue'
import { useToast } from 'vue-toast-notification'
import { storeToRefs } from 'pinia'
import { useLocaleStore } from '@/stores/localeStore'

const phone = ref('')
const toast = useToast()

const localeStore = useLocaleStore()
const { countryIso } = storeToRefs(localeStore)

async function resendValidateCode() {
  if (phone.value.length < 8 || phone.value.length > 15) {
    toast.error('Le numéro de téléphone semble incorrect.')
    return
  }

  try {
    const response = await fetch(config.apiUrl + '/user/resend-verification-code', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        phone: phone.value,
        countryIso: countryIso.value
      })
    })

    if (!response.ok) {
      const data = await response.json()
      throw new Error(data.message || 'Erreur lors de la demande de renvoi du code de validation')
    }

    toast.success('Code de validation renvoyé avec succès !')
  } catch (error) {
    toast.error(error.message)
  }
}
</script>
